<template>
  <b-card-footer class="text-right">
    <b-form-group>
      <b-button
        v-if="showModalType !== 'update-holiday-data'"
        pill
        variant="outline-primary"
        @click="sendForm"
        :disabled="checkValidation"
        >Guardar</b-button
      >
      <b-button
        style="margin-left: 10px"
        variant="outline-danger"
        pill
        @click="closeModal()"
        >Cancel</b-button
      >
    </b-form-group>
  </b-card-footer>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { BCardFooter, BButton, BFormGroup } from 'bootstrap-vue'
import swal from 'sweetalert2'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BButton,
    BCardFooter,
    BFormGroup,
  },
  data() {
    return {
      userData: getUserData(),
    }
  },
  computed: {
    ...mapState('locations', ['checkValidation', 'showModalType']),
  },
  methods: {
    ...mapActions('blockingQuestions', ['sendBlockingForm']),
    ...mapActions('locations', ['updateSchedules', 'updateLocations']),
    ...mapActions('holidays', ['updateHolidays', 'getHolidays']),
    ...mapMutations('locations', ['toggleModal']),
    closeModal() {
      this.toggleModal({ value: false, type: null })
    },
    async sendUpdateLocations() {
      await this.updateLocations()
        .then((response) => {
          this.closeModal()
          swal
            .fire({
              icon: 'success',
              title: '¡Datos actualizados!',
              text: 'El horario fue actualizado',
              timer: 35000,
            })
            .then(async () => {
              //
            })
        })
        .catch((errors) => {
          swal.fire({
            icon: 'error',
            title: '¡Datos no actualizados!',
            text: errors.response.data.message,
            timer: 35000,
          })
        })
    },
    async sendUpdateHoliday() {
      const create = this.showModalType === 'create-holiday' ? true : false
      console.log('footer')
      await this.updateHolidays({create})
        .then((response) => {
          this.closeModal()
          swal
            .fire({
              icon: 'success',
              title: '¡Datos actualizados!',
              text: 'El horario fue actualizado',
              timer: 35000,
            })
            .then(async () => {
              await this.getHolidays()

            })
        })
        .catch((errors) => {
          swal.fire({
            icon: 'error',
            title: '¡Datos no actualizados!',
            text: errors.response.data.message,
            timer: 35000,
          })
        })
    },

    async sendForm() {
      swal
        .fire({
          icon: 'warning',
          title: '¡Los datos se actualizarán!',
          text: '¿Desea guardar el formulario?',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
        })
        .then(async (result) => {
          if (result.value) {
            if (this.showModalType === 'update-location-data') {
              this.sendUpdateLocations()
            } else if (this.showModalType === 'update-holiday-data' || this.showModalType === 'create-holiday') {
              this.sendUpdateHoliday()
            } else {
              await this.updateSchedules()
                .then((response) => {
                  this.closeModal()
                  swal.fire({
                    icon: 'success',
                    title: '¡Datos actualizados!',
                    text: 'El horario fue actualizado',
                    timer: 35000,
                  })
                })
                .catch((errors) => {
                  swal.fire({
                    icon: 'error',
                    title: '¡Datos no actualizados!',
                    text: errors.response.data.message,
                    timer: 35000,
                  })
                })
            }
          }
        })
    },
  },
}
</script>
